import React, { Component } from 'react';
import { Container } from 'reactstrap';
import './ParallaxContainer.css';

export class ParallaxContainer extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Container className={'parallax-container'} style={{ backgroundImage: `url('${this.props.backgroundImageUrl}')` }}/>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/parallax/ParallaxContainer.js